'use client';

import { type CSSProperties, useEffect } from 'react';

import { captureException } from '@/lib/sentry';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
  unstable_retry: () => void;
}

const bodyStyle: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  fontFamily: 'system-ui, -apple-system, sans-serif',
  justifyContent: 'center',
  margin: 0,
  minHeight: '100vh',
};

const cardStyle: CSSProperties = {
  maxWidth: 420,
  padding: 16,
  textAlign: 'center',
};

/**
 * Root layout failures (Next.js 16.2). Must include `html` / `body`; no `generateMetadata` here.
 * Inline styles only — this tree does not inherit `layout.tsx` or Tailwind.
 */
export default function GlobalError({ error, unstable_retry }: GlobalErrorProps) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <html lang='en'>
      <body style={bodyStyle}>
        <div style={cardStyle}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: 12 }}>Something went wrong</h2>
          <p style={{ color: '#555', fontSize: '0.875rem', marginBottom: 20 }}>
            Please try again. If the problem continues, refresh the page.
          </p>
          <button
            onClick={() => unstable_retry()}
            style={{
              backgroundColor: '#dc2626',
              border: 'none',
              borderRadius: 8,
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.875rem',
              padding: '10px 16px',
            }}
            type='button'
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
